const state = () => ({});

const getters = {};

const mutations = {};

const actions = {};

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state,
};
